/** Shared SweetAlert options for admin action dialogs; layout rules live under `.admin-swal` in style.css. */
export const adminSwalOptions = {
  background: "#fff",
  color: "#373737",
  width: 560,
  heightAuto: false,
  customClass: {
    popup: "admin-swal",
    confirmButton: "general-btn me-md-3 mb-2",
    cancelButton: "general-btn-3 mb-2",
    title: "modal-text mt-1 fw-regular",
  },
};
